function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  className: "contactMessage",
  clipRule: "evenodd",
  d: "M4.92969 6.80469C4.37741 6.80469 3.92969 6.35676 3.92969 5.80421C3.92969 5.25167 4.37741 4.80469 4.92969 4.80469C5.48197 4.80469 5.92969 5.25167 5.92969 5.80421C5.92969 6.35676 5.48197 6.80469 4.92969 6.80469",
  fill: "#2A3233"
});
var _ref3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  className: "contactMessage",
  clipRule: "evenodd",
  d: "M8.11719 6.80469C7.56491 6.80469 7.11719 6.35676 7.11719 5.80421C7.11719 5.25167 7.56491 4.80469 8.11719 4.80469C8.66947 4.80469 9.11719 5.25167 9.11719 5.80421C9.11719 6.35676 8.66947 6.80469 8.11719 6.80469",
  fill: "#2A3233"
});
var _ref4 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  className: "contactMessage",
  clipRule: "evenodd",
  d: "M10.0509 1H2.94838C1.87677 1 1 1.83572 1 2.85731V8.43983C1 9.46143 1.87677 10.2964 2.94838 10.2964H3.8419V12.7574C3.8419 12.963 4.09458 13.0748 4.25974 12.9433L7.57504 10.2964H10.0509C11.1225 10.2964 12 9.46143 12 8.43983V2.85731C12 1.83572 11.1225 1 10.0509 1Z",
  stroke: "#2A3233"
});
function SvgContactSupport(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, ["title", "titleId"]);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 14,
    viewBox: "0 0 13 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContactSupport);
export default __webpack_public_path__ + "static/media/contact-support.2445d4c4.svg";
export { ForwardRef as ReactComponent };